import React, { Component, createContext } from 'react';

const context = createContext({});
const { Provider, Consumer } = context;

const Tab = ({ id, children }) => (
    <Consumer>
        {({ changeActiveTab, activeTabId }) => (
            <div style={{ flex: 1 }} onClick={() => changeActiveTab(id)}>
                {React.cloneElement(children, {
                    className: activeTabId === id ? 'active' : null,
                })}
            </div>
        )}
    </Consumer>
);

const TabPanel = ({ whenActive, children }) => (
    <Consumer>{({ activeTabId }) => whenActive === activeTabId && children}</Consumer>
);

class TabSwitcher extends Component {
    state = {
        activeTabId: 0,
    };

    changeActiveTab = newTabId => {
        this.setState({ activeTabId: newTabId });
    };

    render() {
        const {
            changeActiveTab,
            state: { activeTabId },
        } = this;

        return <Provider value={{ changeActiveTab, activeTabId }}>{this.props.children}</Provider>;
    }
}

export default TabSwitcher;
export { TabPanel, Tab };



// WEBPACK FOOTER //
// ./src/UI/Context/TabsContext/index.js